// extracted by mini-css-extract-plugin
export default {"MainbPage":"styles_MainbPage__uvoeC"};